import AppModel from "app/models/App";
import CheckMyNumbersController from "app/controllers/CheckMyNumbers";
import cmnTemplates from "app/templates/nunjucks/build/nunjucks-templates.cmn";

let appCtx = new AppModel();
let checkmynumbersController = new CheckMyNumbersController(appCtx);
checkmynumbersController.route();

console.log("pages checkmynumbers started");
